/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_EditorMenciones as EditorMenciones,
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_Modal as Modal,
  rec_React as React,
  rec_Ro as Ro,
  rec_api as api,
  rec_obtenerUsuario as obtenerUsuario,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function NuevoHilo({ proyecto: e, onClose: t, onGuardado: n }) {
  let [r, i] = (0, React.useState)(``),
    [a, o] = (0, React.useState)(``),
    [s, c] = (0, React.useState)([]),
    [l, u] = (0, React.useState)(``);
  async function f(i) {
    i.preventDefault();
    try {
      (await api(`/discusiones`, {
        method: `POST`,
        body: JSON.stringify({
          proyectoId: e.id,
          titulo: r,
          cuerpo: a,
          creadoPorNombre: obtenerUsuario()?.nombre,
          menciones: s,
        }),
      }),
        n(),
        t());
    } catch (e) {
      u(e.message);
    }
  }
  return (
    <Modal
      titulo={`Nuevo hilo`}
      onClose={t}
      children={
        <form
          onSubmit={f}
          className={`flex flex-col gap-3`}
          children={[
            <input
              className={Lo}
              placeholder={`Título`}
              value={r}
              onChange={(e) => i(e.target.value)}
              required={!0}
              autoFocus={!0}
            />,
            <EditorMenciones
              value={a}
              onChange={o}
              onMenciones={c}
              miembros={e.miembros ?? []}
              rows={5}
              placeholder={`Planteamiento — @ para mencionar`}
              className={`${Lo} min-h-28`}
            />,
            l && <p className={`text-sm text-(--error)`} children={l} />,
            <div
              className={`flex justify-end gap-2`}
              children={[
                <button
                  type={`button`}
                  onClick={t}
                  className={zo}
                  children={`Cancelar`}
                />,
                <button type={`submit`} className={Ro} children={`Publicar`} />,
              ]}
            />,
          ]}
        />
      }
    />
  );
}
